/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Government = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Government 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M3 6.288V8h18V6.288l-9-4.091-9 4.09ZM11.38.282 1.88 4.6A1.5 1.5 0 0 0 1 5.966V8.5A1.5 1.5 0 0 0 2.5 10H3v8h-.5A1.5 1.5 0 0 0 1 19.5v2A1.5 1.5 0 0 0 2.5 23h19a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5H21v-8h.5A1.5 1.5 0 0 0 23 8.5V5.966a1.5 1.5 0 0 0-.88-1.366L12.62.282a1.5 1.5 0 0 0-1.24 0ZM19 18v-8h-2v8h2Zm-4 0v-8h-2v8h2Zm-4 0v-8H9v8h2Zm-4 0v-8H5v8h2Zm-4 3v-1h18v1H3Z"
        className="Union"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const GovernmentIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'government-icon'}
      icon={Government}
      {...props}
      size={size}
    />
  );
};
